import { CommonModule } from '@angular/common';
import { Component, HostBinding, Inject } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { DynamicIconDirective } from '@nai-libs/directives/dynicon';

@Component({
  selector: 'nai-alert',
  standalone: true,
  imports: [CommonModule, DynamicIconDirective, MatSnackBarModule],
  template: `
    <ng-container *ngIf="data.message">
      <button class="alert-button-close" (click)="snackBarRef.dismiss()">
        <span naiDynIcon [path]="'assets/icons/close.svg'"></span>
      </button>
      <figure>
        <img [src]="data.imageUrl" />
      </figure>
      <div class="alert-message-container">
        <p>{{ data.message }}</p>
      </div>
    </ng-container>
  `,
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      alertType: 'info' | 'error' | 'warning' | 'success';
      message: string;
      imageUrl: string;
      mode: string
    },
    public snackBarRef: MatSnackBarRef<AlertComponent>
  ) {}

  @HostBinding('class') get alertTypeClass() {

    return `alert-snackbar--${this.data.alertType} ${this.data.mode ? 'alert-snackbar--' + this.data.mode : ''}`;
  }
}
